import React, { type ReactNode } from 'react';

export interface NavigationSectionContextValue {
	sectionName: string;
	includeSectionInPath?: boolean;
}

const NavigationSectionContext = React.createContext<NavigationSectionContextValue | null>(null);

export interface NavigationSectionProviderProps extends NavigationSectionContextValue {
	children: React.ReactNode;
}

export function NavigationSectionProvider(props: NavigationSectionProviderProps): ReactNode {
	return <NavigationSectionContext.Provider value={props}>{props.children}</NavigationSectionContext.Provider>;
}

export function useNavigationSectionContext<T>(): NavigationSectionContextValue | null {
	return React.useContext(NavigationSectionContext as React.Context<NavigationSectionContextValue | null>);
}
